// export  const API_URL = 'http://localhost:8088'  //用户端后端接口地址
// export  const Enterprise_API_URL = 'http://localhost:8081'  //企业端前台地址

export  const API_URL = '/api'  //用户端后端接口地址
export  const websocket_API_URL = `/wsApi` //websocket 服务器地址
export  const Enterprise_API_URL = '/company'  //企业端前台地址